<template>
  <div class="absolute h-full w-full flex items-center justify-center bg-gray-500/30" v-if="loading">
    <LoadingSpinner class="w-10 h-10"/>
  </div>

  <div class="grid grid-cols-2 p-2">
    <CategoryCard v-for="category in categories"
                  :key="category.id"
                  :category="category"/>
  </div>

</template>

<script>
import {getCategories} from "@/API/API";
import LoadingSpinner from "@/components/General/LoadingSpinner";
import CategoryCard from "@/components/CategoryCard";

export default {
  name: "CategoryPage",
  components: {CategoryCard, LoadingSpinner},
  data() {
    return {
      categories: [],
      loading: false
    }
  },
  created() {
    this.getCategory();
  },
  methods: {
    async getCategory() {
      switch (this.$route.params.type) {
        case 'shop':
          this.$pageTitle.value = 'فروشگاه'
          break
        case 'restaurant':
          this.$pageTitle.value = 'رستوران'
          break
        case 'caffe':
          this.$pageTitle.value = 'کافی شاپ'
          break
      }
      this.loading = true
      this.categories = []
      this.categories = (await getCategories(this.$route.params.type)).data
      this.loading = false
    },
  },
  watch: {
    '$route'() {
      this.getCategory()
    }
  }
}
</script>

<style scoped>

</style>